<h1 class="tw-border-b tw-border-gray-200 tw-pb-2 tw-mb-5">Launching in AppStream 2.0 Native Client</h1>

<div>
  <div *ngIf="isWorking">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
  <div *ngIf="env">
    <p><strong>AVEVA ERM v{{env.version}} {{env.name}}</strong></p>
    <p><strong>Id:</strong> {{env.environmentId}} <lib-env-labels [env]="env"></lib-env-labels></p>
    <p><strong>Description:</strong> {{env.description}}</p>
    <p><strong>Region:</strong> {{env.region?.displayName}}</p>
    <p><strong>Status:</strong>&nbsp;<lib-env-status [env]="env"></lib-env-status></p>
    <p>
      <strong>Is the native client not starting?</strong>
      <br />
      To launch AVEVA ERM locally, please make sure you have installed the latest native AppStream 2.0 client for Windows.
    </p>
    <div fxLayout="row" fxLayoutGap="8px">
      <a mat-raised-button color="primary" href="https://clients.amazonappstream.com" target="_blank">Download the AppStream Client Software</a>
      <a mat-raised-button [routerLink]="['/erm/launch', fleetKind, env.environmentId, 'browser']">Launch in browser instead</a>
    </div>
  </div>
  <div *ngIf="isErmUnavailable">
    <p>AVEVA ERM is currently unavailable. Please contact your AVEVA ERM administrator.</p>
  </div>
</div>